import {Component, OnInit, ViewChild} from '@angular/core';
import {BsModalRef, BsModalService} from "ngx-bootstrap";
import {FormBuilder, Validators} from "@angular/forms";
import {Router} from "@angular/router";
import {NotifierService} from "angular-notifier";
import {UserService} from "../../../service/user.service";

@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.scss']
})
export class NewsComponent implements OnInit {
  reviwes: any;
  modalRef: BsModalRef;
  @ViewChild("errorModal", {static: true}) errorModal;
  @ViewChild("addModal", {static: true}) addModal;
  @ViewChild("view", {static: true}) view;
  newsForm: any;
  up: boolean;
  upId: any;
  note: any;
  noteTitle: any;
  constructor(private formBuilder: FormBuilder, private route: Router, private notifier: NotifierService,
              private userService: UserService, private modalService: BsModalService,) {
    this.newsForm = this.formBuilder.group({
      title: ["", [Validators.required]],
      desc: ["", [Validators.required]],
    });
  }

  ngOnInit() {
    this.getAllClientReviews();
  }



  getAllClientReviews(){
    this.userService.getAllNote().subscribe(
      res=>{
        if (res.responseCode == 200) {
          this.reviwes = res.data;
        } else {
          this.notifier.notify('danger', res.responseDesc);
        }
      }
    )
  }

  reject(id: any) {

  }

  viewMore(pac) {
    this.note =pac.description;
    this.noteTitle=pac.title
    this.view.show();
  }

  addNew(){
    this.addModal.show();
  }

  createNotice(){
    let req ={
      description: this.newsForm.controls.desc.value,
      title: this.newsForm.controls.title.value,
    }

  this.userService.createNote(req).subscribe(
    res=>{
      if (res.responseCode == 200) {
        this.notifier.notify('success', res.responseDesc);
        this.addModal.hide();
        this.getAllClientReviews();
        this.newsForm.reset();
      } else {
        this.notifier.notify('danger', res.responseDesc);
      }
    }
  )
  }

  updateNotice(){
    let req ={
      id:this.upId,
      description: this.newsForm.controls.desc.value,
      title: this.newsForm.controls.title.value,
    }

    this.userService.createNote(req).subscribe(
      res=>{
        if (res.responseCode == 200) {
          this.notifier.notify('success', res.responseDesc);
          this.addModal.hide()
          this.getAllClientReviews();
          this.newsForm.reset();
        } else {
          this.notifier.notify('danger', res.responseDesc);
        }
      }
    )
  }

  update(pac: any) {
    this.addModal.show();
    this.up=true;
    this.upId=pac.id;
    this.newsForm.controls['title'].setValue(pac.title);
    this.newsForm.controls['desc'].setValue(pac.description);
  }

  dlete(id) {
    this.userService.deleteNote(id).subscribe(
      res=>{
        if (res.responseCode == 200) {
          this.notifier.notify('success', res.responseDesc);
          this.getAllClientReviews();
        } else {
          this.notifier.notify('danger', res.responseDesc);
        }
      }
    )
  }
}
